module.exports = __webpack_public_path__ + "static/media/sunset.b2522c0d.svg";